var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.value * 100 + '%' }),expression:"{ content: value * 100 + '%' }"}],staticClass:"modern-thermo-icon__container"},[_c('div',{class:['modern-thermo-icon', _vm.getScoreClass(_vm.value), { 'large-size': _vm.isLarge }]})])
}
var staticRenderFns = []

export { render, staticRenderFns }